import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getOperationIndustrieStub } from '../../../../config/operations-industrie';

export default function AirComprimePage() {
  const parcours = getOperationIndustrieStub('air-comprime');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="industrie"
      segment="operations"
      segmentLabel="Utilités & process"
      crossLinks={[
        {
          label: 'CEE IND-UT / IND-BA',
          href: '/industrie/aides/cee-ind',
          iconName: 'sparkles',
          hint: 'Primes énergie sur la fiche IND-UT-117',
        },
        {
          label: 'Récupération chaleur fatale',
          href: '/industrie/operations/recuperation-chaleur',
          iconName: 'flame',
          hint: "Valoriser la chaleur des compresseurs",
        },
        {
          label: 'Variateurs de vitesse ventilation (fiche IND-UT-114)',
          href: '/industrie/operations/variateurs',
          iconName: 'zap',
          hint: 'Variation de vitesse sur compresseur principal',
        },
      ]}
      crossLinksAllLabel="Toutes les aides industrie"
      crossLinksAllHref="/industrie/aides"
    />
  );
}
